import { ItemPageSellerBadgesInfoDto } from '@marketplace-web/profile/profile-data'

import { ItemPageSellerBadgesInfoPluginModel } from './types'

export const getItemPageSellerBadgesInfoPluginModel = (
  sellerBadgesInfoDto: ItemPageSellerBadgesInfoDto,
): ItemPageSellerBadgesInfoPluginModel => {
  return sellerBadgesInfoDto
}
